export class ResetPasswordInitRequest {
    public email: string = "";
}